import type { PricingFormProps } from "src/components"
import {
	AlwaysVatDeductibleBasicPricingForm,
	AustraliaNetPricePricingForm,
	BasicPricingForm,
	JapanVehicleAndMiscPricingForm,
} from "src/components"
import { CanadaPriceBreakdownPricingFormContainer } from "./canadaPriceBreakdown/CanadaPriceBreakdownPricingFormContainer"
import { ExtraCostsPriceBreakdownPricingFormContainer } from "./extraCostsPriceBreakdown/ExtraCostsPriceBreakdownPricingFormContainer"

export const PricingFormContainer = ({ ...props }: PricingFormProps) => {
	switch (props.pricingUseCase) {
		case "BASIC":
			return <BasicPricingForm {...props} />
		case "ALWAYS_VAT_DEDUCTIBLE_BASIC":
			return <AlwaysVatDeductibleBasicPricingForm {...props} />
		case "AUSTRALIA_NET_PRICE":
			return <AustraliaNetPricePricingForm {...props} />
		case "CANADA_PRICE_BREAKDOWN":
			return <CanadaPriceBreakdownPricingFormContainer {...props} />
		case "JAPAN_VEHICLE_AND_MISC":
			return <JapanVehicleAndMiscPricingForm {...props} />
		case "EXTRA_COSTS_PRICE_BREAKDOWN":
			return <ExtraCostsPriceBreakdownPricingFormContainer {...props} />
	}
}
